<template>
  <form
    action=""
    @submit.prevent="onSubmit"
  >
    <ds-textarea
      v-model="description"
      :validate-rules="{required: true}"
      name="feature-request"
      rows="7"
    />
    <div :class="$style['btn-wrapper']">
      <ds-button>
        Wyślij
      </ds-button>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      description: ""
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("onSubmit");
        }
      });
    }
  }
};
</script>

<style lang="scss" module>
.btn-wrapper {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/app/dashboard/forms/feature-request-form.vue